import React from "react";

import { formatAddress, capitalizeString } from "../../../utilities/helpers";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Alert from "react-bootstrap/Alert";

import { WarningCard } from "../../../components/WarningCard";
import { Spinner } from "../../../components/LoadingContainer/Spinner";
import { LoadingContainer } from "../../../components/LoadingContainer";
import { InfoIcon } from "../../../components/InfoIcon";

export default function CreatePackageModal({
  showPackage,
  isLoading,
  loadData,
  venues,
  room,
  seatmapId,
  handleVenue,
  handleConfiguration,
  handleClose,
  handleNext,
  isSaving,
  seasons,
  seasonId,
  setSeason,
  season,
  setType,
  type,
  types,
  flexPackName,
  handleFlexPackName,
  handleFlexPackPrice,
  price,
  alert,
}) {
  return (
    <Modal
      centered
      animation={false}
      fullscreen="md-down"
      show={showPackage}
      onHide={handleClose}
      backdrop="static"
      contentClassName="h-xs"
      onShow={() => loadData()}
    >
      <Modal.Body className="d-flex-column">
        {isLoading ? (
          <LoadingContainer />
        ) : (
          <>
            <div className="modal-body-heading">
              <h1 className="modal-body-heading-title">Create Package</h1>
            </div>
            {alert.show && (
              <>
                <Alert variant={alert.variant} className="mb-5">
                  <p>{alert.message}</p>
                </Alert>
              </>
            )}
            <Form.Group className="form-group" controlId="season">
              <Form.Label>Season</Form.Label>
              <Form.Select
                name="season"
                onChange={(e) => setSeason(e.target.value)}
                value={season || ""}
                autoFocus
                required
              >
                <option disabled hidden value="">
                  Select season
                </option>
                {seasons &&
                  seasons.map((season, i) => (
                    <option value={season.id} key={i}>
                      {season.organization.name} - {season?.name}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="form-group" controlId="type">
              <Form.Label>Type</Form.Label>
              <Form.Select
                name="type"
                onChange={(e) => setType(e.target.value)}
                value={type || ""}
                required
              >
                <option disabled hidden value="">
                  Select package type
                </option>
                {types.map((type, index) => (
                  <option value={type.key} key={index}>
                    {type.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            {type && type === "flex-package" && (
              <>
                <Form.Group className="form-group" controlId="name">
                  <div className="form-label--flex">
                    <Form.Label>Name</Form.Label>
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip>
                          Maximum 100 characters. No HTML or emoji allowed
                        </Tooltip>
                      }
                    >
                      <Button variant="link">
                        <InfoIcon />
                      </Button>
                    </OverlayTrigger>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter a name for flex package"
                    name="name"
                    value={flexPackName}
                    onChange={handleFlexPackName}
                    required={type === "flex-package"}
                  />
                </Form.Group>
                <Form.Group className="form-group" controlId="price">
                  <Form.Label>Price</Form.Label>
                  <Form.Control
                    name="price"
                    placeholder="Amount"
                    pattern="^[0-9.]*$"
                    onChange={(e) =>
                      handleFlexPackPrice(
                        e.target.value === "" || e.target.validity.valid
                          ? e
                          : price,
                      )
                    }
                    value={price}
                    required={type === "flex-package"}
                  />
                </Form.Group>
              </>
            )}
            {type && type === "season-package" && (
              <>
                <Form.Group className="form-group" controlId="venue">
                  <Form.Label>Venue</Form.Label>
                  <Form.Select
                    name="venue"
                    onChange={handleVenue}
                    value={room?.uuid || ""}
                    required={type === "season-package"}
                  >
                    <option disabled hidden value="">
                      Select venue
                    </option>
                    {venues &&
                      venues.map((option, index) => (
                        <optgroup
                          label={`${option?.name} - ${formatAddress(option)}`}
                          key={index}
                        >
                          {option.rooms?.map((room, i) => (
                            <option
                              value={room.uuid}
                              data-venue={option}
                              key={i}
                            >
                              {capitalizeString(room.name)}
                            </option>
                          ))}
                        </optgroup>
                      ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="form-group" controlId="configuration">
                  <Form.Label>Configuration</Form.Label>
                  <Form.Select
                    name="configuration"
                    value={seatmapId || ""}
                    onChange={handleConfiguration}
                    required={type === "season-package"}
                  >
                    <option hidden value="">
                      Select configuration
                    </option>
                    {room?.seatmaps &&
                      room?.seatmaps.map((option, index) => (
                        <option value={option.id} key={index}>
                          {capitalizeString(option.name)}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
                <WarningCard
                  text="Events must share the same configurations to be assigned to a package"
                  variant="primary"
                  margin="mt"
                />
              </>
            )}
            <Stack
              direction="horizontal"
              className="justify-content-between btn-group-flex"
            >
              <Button variant="default" size="lg" onClick={handleClose}>
                Cancel
              </Button>
              <Button
                size="lg"
                className={`btn-width btn-width-xxl ${!isSaving ? "btn-next" : ""}`}
                disabled={
                  (type === "flex-package"
                    ? !flexPackName || !price
                    : !room || !seatmapId) ||
                  !type ||
                  !season ||
                  isSaving
                }
                onClick={handleNext}
              >
                {isSaving ? <Spinner /> : "Save and continue"}
              </Button>
            </Stack>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
